// @flow
/* eslint-disable no-param-reassign */

/**
 * Make a query string from parameters.
 * @param  {Object} params    key => value (value can be an array)
 * @return {String}
 */
function encode(key: string, value: string) {
  return `${key}=${encodeURIComponent(value)}`;
}

type Params = {
  [string]: any,
};
/**
 * Make a query string from parameters.
 * @param  {Object} params    key => value (value can be an array)
 * @return {String}
 */
function makeQueryString(params: Params): string {
  const paramsList: Array<string> = Object.keys(params).reduce((acc, key) => {
    const value = params[key];

    if (Array.isArray(value)) {
      value.forEach(val => {
        acc = acc.concat(encode(key, val));
      });
      // Allow booleans and zero-number
    } else if (value !== '' && value !== undefined && value !== null) {
      acc = acc.concat(encode(key, value));
    }

    return acc;
  }, []);

  return paramsList.join('&');
}

export default makeQueryString;
